<template>
  <div>
    <div
      class="mapStyle"
      :id="settings.name"
      :style="settings.style"
    >
      <v-flex dflex class="zoomControls" v-if="settings.controls.zoomControls">
        <v-layout row>
          <v-layout column>
            <v-card class="divBehindButtons">
              <v-card class="zoomControlCard v-card--flat">
                <p
                  class="zoomControlPelement"
                  style="margin-bottom: 0;"
                  @click="changeZoom('zoomIn')"
                >
                  <v-icon
                    class="filterIcon"
                    color="black"
                    small
                  >add
                  </v-icon>
                </p>
              </v-card>
              <v-divider></v-divider>
              <v-card class="zoomControlCard v-card--flat">
                <p
                  class="zoomControlPelement"
                  style="margin-bottom: 0;"
                  @click="changeZoom('zoomOut')"
                >
                  <v-icon
                    class="filterIcon"
                    color="black"
                    small
                  >remove
                  </v-icon>
                </p>
              </v-card>
            </v-card>
          </v-layout>
          <v-card style="height: 50%; margin: 0 1em;">
            <v-slider
              style="margin: 0 1em !important; height: 2em;"
              v-model="zoomLevel"
              :min="appConfigObject.map.minZoom"
              :max="appConfigObject.map.maxZoom"
              @change="zoomSlider()"
              :step="(appConfigObject.map.maxZoom - appConfigObject.map.minZoom) / 100"
              color="black"
            ></v-slider>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex v-if="settings.controls.filterOption" class="filterOverlay" d-flex xs1>
        <v-menu :close-on-content-click="false" offset-y class="filterBtn">
          <template v-slot:activator="{ on }">
            <v-card class="zoomControlCard" v-on="on">
              <p class="zoomControlPelement"
                 style="margin-bottom: 0;">
                <v-icon
                  small
                  class="filterIcon"
                  color="black"
                >sort
                </v-icon>
              </p>
            </v-card>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in filterOptions"
              :key="index"
            >
              <v-list-tile-title style="padding-right: 1em;">{{ item.name }}</v-list-tile-title>
              <v-list-tile-action>
                <v-switch @change="fireFilterMarkers" v-model="item.selected"></v-switch>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <v-flex class="mapAttributionOverlay" d-flex xs4 v-if="!sideBar">
        <a href="https://www.openstreetmap.org/copyright"
           target="_blank"
           class="hrefMap"
        >&copy; OpenStreetMap contributors</a>
      </v-flex>
      <transition
        name="midCircleAnimation"
        enter-active-class="animated slideInRight faster"
        leave-active-class="animated slideOutRight faster"
      >
        <v-layout fill-height v-if="sideBar" class="sideBar">
          <v-card width="400">
            <v-img :src="locationDetails.PictureURL"
                   min-width="400"
                   max-width="400"
                   max-height="150"
            ></v-img>
            <v-flex ma-3>
              <h2>{{ locationDetails.Name }}</h2>
              <v-divider style="margin: 1em 0;"></v-divider>
              <p>{{locationDetails.Description}}</p>
              <v-flex xs12 v-if="locationDetails.Email !== ''">
                <b>{{$translate('EMAIL')}}:</b>
                <a :href="'mailto:' + locationDetails.Email">
                  {{locationDetails.Email}}
                </a>
              </v-flex>
              <v-flex xs12 v-if="locationDetails.Website !== ''">
                <b>{{$translate('VRI_WEBSITE')}}:</b>
                <a :href="locationDetails.Website">
                  {{locationDetails.Website}}
                </a>
              </v-flex>
              <v-flex xs12 v-if="locationDetails.OpeningHours !== ''">
                <b>{{$translate('OPEN_HOURS')}}:</b>
                {{locationDetails.OpeningHours}}
              </v-flex>
              <v-divider style="margin: 1em 0;"></v-divider>
              <v-flex xs12 v-if="locationDetails.PartnerLevel === 3">
                <v-list two-line>
                  <template v-for="(item, index) in locationDetails.Events">
                    <v-list-tile
                      :key="item.title"
                      avatar
                      @click="">
                      <v-list-tile-avatar>
                        <img :src="item.ThumbnailPicture">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.Name"></v-list-tile-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon
                          @click="goTo(item.EventId)">
                          keyboard_arrow_right</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-flex>
            </v-flex>

          </v-card>
        </v-layout>
      </transition>
      <transition
        name="midCircleAnimation"
        enter-active-class="animated fadeIn faster"
        leave-active-class="animated fadeOut faster"
      >
        <v-flex class="bottomPopup" d-flex v-if="bottomPopup">
        <v-card>
          <v-layout row>
            <v-flex xs3 style="margin: 4px;">
              <v-img
                :src="locationDetails.PictureURL"
                max-height="64"
                max-width="96"
                min-height="64"
                min-width="96"
              >
              </v-img>
            </v-flex>
            <v-flex xs9 style="margin: 4px;" fill-height>
              <v-layout column justify-center fill-height>
                <h3> {{ locationDetails.Name }} </h3>
                <p v-if="locationDetails.Description.length < 80"> {{ locationDetails.Description }} </p>
              </v-layout>
            </v-flex>
          </v-layout>
          <p class="line-clamp" style="margin: 4px;" v-if="locationDetails.Description.length > 80"> {{ locationDetails.Description }} </p>
        </v-card>
      </v-flex>
      </transition>
    </div>
<!--    <div id="popup" class="ol-popup">-->
<!--      <a href="#" id="popup-closer" class="ol-popup-closer"></a>-->
<!--    </div>-->
  </div>
</template>

<script>
import MapObject from "./MapObject";
import {store} from "../store";
import appConfig from "../../config/app_config";
import {mapGetters} from "vuex";
import animate from 'animate.css';

export default {
  name: 'Map',
  data() {
    return {
      slider: 45,
      zoomLevel: 18,
      map: {},
      appConfigObject: appConfig,
      filterMenu: false,
      filterOptions: [],
      bottomPopup: false,
      sideBar: false,
      locationDetails: {},
    };
  },
  computed: {
    ...mapGetters({
      _getFiltersForMap: 'getFiltersForMap',
    }),
  },
  watch:{
    _getFiltersForMap(newV, oldV){
      if (newV !== oldV){
        let filters = [];
        this.$store.getters.getFiltersForMap.forEach(filter => {
          filters.push({name: filter, selected: false});
        })
        this.filterOptions = filters;
      }
    },
  },
  props: {
    settings: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  created() {
    window.EventBus.listen('showBottomPopup', this.showBottomPopup);
    window.EventBus.listen('showSideBar', this.showSideBar);
  },
  mounted() {
    this.init();
    if (store.getters.getCenterPointForMap.length !== 0) {
      this.map._updateCenterPoint(store.getters.getCenterPointForMap);
    } else {
      this.map._updateCenterPoint(appConfig.map.center);
    }
  },
  methods: {
    init() {
      this.map = new MapObject(this.settings);
      setTimeout(()=> {
        this.zoomLevel = this.map.map.getView().getZoom();
      }, 100);
      setTimeout(()=> {
        const self = this;
        this.map.map.on('moveend', function () {
          self.zoomLevel = self.map.map.getView().getZoom();
        });
      }, 1000);
    },
    showBottomPopup(locationDetails) {
      this.sideBar = false;
      this.locationDetails = locationDetails;
      this.bottomPopup = true;
    },
    showSideBar(locationDetails) {
      this.bottomPopup = false;
      this.locationDetails = locationDetails;
      this.sideBar = true;
    },
    fireFilterMarkers() {
      const toSendFilters = [];
      let filtersTurnedOn = false;
      this.filterOptions.forEach(item => {
        if (item.selected) toSendFilters.push(item.name);
        if (!item.selected) filtersTurnedOn = true;
      });
      console.log("Lorenzo toSendFilters", toSendFilters);
      filtersTurnedOn ? window.EventBus.fire('showFilteredMarkersOnMap', toSendFilters) : window.EventBus.fire('showFilteredMarkersOnMap', null);
    },
    changeZoom(zoomType) {
      const view = this.map.map.getView();
      let zoom = view.getZoom();
      if (zoomType === 'zoomOut') {
        zoom -= 1;
      } else {
        zoom += 1;
      }
      view.animate(
        {
          zoom: zoom,
          duration: 200,
        },
      );
    },
    goTo(EventId) {
      this.$router.push({
        path: "/" + store.getters.getRegion +'/' + 'event=' + EventId
      });
    },
    zoomSlider() {
      const view = this.map.map.getView();
      view.animate(
        {
          zoom: this.zoomLevel,
          duration: 200,
        },
      );
    },
  },
  beforeDestroy() {
    window.EventBus.removeListener('showBottomPopup', this.showBottomPopup);
    window.EventBus.removeListener('showSideBar', this.showSideBar);
    this.$store.commit('setFiltersForMap', {});
    this.map.selfDestruct();
    this.map = null;
  },
};

</script>

<style scoped lang="scss">
  .mapStyle {
    background-color: #acd3de;
    position: relative;
    bottom: 0;
  }
  .mapStyle div {
    width: auto;
    height: auto;
    border-radius: 10px;
  }
  .mapStyle .filterOverlay {
    z-index: 99;
    position: absolute;
    top: 90px;
    left: 0;
    min-height: 28px;
    max-height: 28px;
    clear: both;
    color: black;
    margin-left:calc(0.5%);
    border: none;
    cursor: pointer;
  }

  .zoomControlCard {
    max-width: 28px;
    min-width: 28px;
  }

  .mapStyle .zoomControls {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    clear: both;
    color: black;
    margin-left:calc(0.5%);
    margin-top:calc(0.5%);
    border: none;
    cursor: pointer;
  }
  .mapStyle .mapAttributionOverlay {
    z-index: 100;
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right:calc(1%);
    clear: both;
    border: none;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bottomPopup {
    z-index: 10;
    animation-duration: 200ms;
    position: absolute;
    bottom: 0;
    margin-bottom:calc(1%);
    left: calc(50% - 190px);
    right: calc(50% - 190px);
    width: 380px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hrefMap {
    font-size: 10px;
    color: black;
    text-align: end;
  }
  .filterDialog {
    max-height: calc(50vh - 100px) !important;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .zoomControlPelement {
    padding: 6px;
    margin-bottom: 0px;
    text-align: center;
  }
  .divBehindButtons {
    background-color: white;
  }
  .sideBar {
    animation-duration: 200ms;
    width: 400px;
    height: 100% !important;
    min-width: 400px;
    z-index: 100;
    position: absolute;
    top: 0;
    margin-bottom:calc(1%);
    right: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0 !important;
  }
  .sideBar div {
    border-radius: 0 !important;
  }
  .line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
